import { render } from "./StepsSection.vue?vue&type=template&id=7b0998f0&scoped=true"
import script from "./StepsSection.vue?vue&type=script&lang=js"
export * from "./StepsSection.vue?vue&type=script&lang=js"

import "./StepsSection.vue?vue&type=style&index=0&id=7b0998f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0998f0"]])

export default __exports__